// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fHtY","left":"styles_left__1uE8H"};